/**
 * Creates a new function that limits calls to func to once every given timeframe.
 *
 * @param {Function} func     The function
 * @param {Integer}  interval The inverval, in ms
 * @return {Function} The function
 */
const throttle = ( func, interval ) => {
	let lastCall = 0;

	// eslint-disable-next-line space-before-function-paren
	return function () {
		const now = Date.now();
		if ( lastCall + interval < now ) {
			lastCall = now;
			return func.apply( this, arguments );
		}
	};
};

export default throttle;
